import { ref, watch } from '@vue/composition-api';

import { ActionStore } from './action';

export const useUIState = (actionStore: ActionStore) => {

  const summaryFocused = ref(false);

  watch(actionStore.action, () => {
    summaryFocused.value = false;
  });

  return {
    summaryFocused
  };
};

export type UIStateStore = ReturnType<typeof useUIState>;
